import { Suspense } from 'react';
import type { IConfigProps } from './context/ConfigContext';
import { RpcClientFactory } from 'gw-edge-client';
import logFactory from 'c9-js-log-client';
import ReactDOM from 'react-dom/client';
import { v4 } from 'uuid';
import { type MutableSnapshot, RecoilRoot } from 'recoil';
import LoggerContext from './context/LoggerContext';
import App from './App';
import ErrorBoundaryComponent from './shared_components/ErrorBoundaryComponent/ErrorBoundaryComponent';
import { LoadingDots } from '@flos/react-ui';
import { topConfigContextAtom } from './recoil/atoms/topConfigContextAtom';
import { setCookie } from './services/utils/cookieUtil';

const context = (window as any) || {};

context.TopOnlineSales = (function () {
    function boostrapApplication(
        config: IConfigProps,
        boostrapElement: Element | DocumentFragment
    ): void {
        RpcClientFactory.createInstance(config);
        const logger = logFactory(config.endpointConfig.logger, config.appName, 'info');
        void logger.info(`Starting up application ${logger.appName}`);
        const root = ReactDOM.createRoot(boostrapElement);
        setCookie('top_lb_affinity_token', v4(), true);

        root.render(
            <LoggerContext.Provider value={logger}>
                <RecoilRoot
                    initializeState={({ set }: MutableSnapshot): void => {
                        set(topConfigContextAtom, config);
                    }}
                >
                    <ErrorBoundaryComponent>
                        <Suspense
                            fallback={
                                <div style={{ minHeight: '60vh' }}>
                                    <LoadingDots />
                                </div>
                            }
                        >
                            <App />
                        </Suspense>
                    </ErrorBoundaryComponent>
                </RecoilRoot>
            </LoggerContext.Provider>
        );
    }
    return boostrapApplication;
})();
